import { createColumnHelper } from "@tanstack/react-table";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchInquiryDownload,
  useInquiryList,
} from "../../../../api/inquiries/1on1-inquiry/use-1on1-inquiry";
import Table from "../../../../components/ui/Table/Table";
import { convertDateToDateTime } from "../../../../helper/formatDate/formate-date";
import Modal from "../../../../components/ui/Modal/Modal";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexVal =
          page === 1 ? total - index : total - index - (page - 1) * pageSize;

        return <div>{indexVal}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.status, {
      header: "처리상태",
      cell: (info) => {
        const val = info.getValue();
        return (
          <div>
            {val ? (
              val === "PENDING" ? (
                <span className="text-[#e80000]">답변대기</span>
              ) : (
                "답변완료"
              )
            ) : (
              "-"
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.hospitalMember?.email, {
      header: "아이디(이메일주소)",
      cell: (info) => {
        const val = info.getValue();

        const email =
          val?.length > 10 ? (
            <div>
              {val?.substring(0, 25)}
              <br />
              {val?.slice(25)}
            </div>
          ) : (
            val
          );
        return <div className="line-clamp-2">{val ? email : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.hospital?.name, {
      header: "병원명",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.title, {
      header: "문의 제목",
      cell: (info) => {
        const val = info.getValue();
        const title = val?.length > 15 ? val?.substring(0, 15) + "..." : val;
        return <div>{title ? title : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.question, {
      header: "문의 내용",
      cell: (info) => {
        const val = info.getValue();
        const question = val?.length > 15 ? val?.substring(0, 15) + "..." : val;
        return <div>{question ? question : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "문의일시",
      cell: (info) => {
        const val = info.getValue();
        const date = convertDateToDateTime(val);
        return <div>{val ? date : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.answeredAt, {
      header: "답변일시",
      cell: (info) => {
        const val = info.getValue();
        const date = convertDateToDateTime(val);
        return <div>{val ? date : "-"}</div>;
      },
    }),

    columnHelper.display({
      header: "자세히보기",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function ButtonActions(props) {
  const id = props.row.original?.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`inquiry/${id}`)}
      className="w-12 p-[3px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      상세
    </button>
  );
}

export function InquiryTable(props) {
  const { filter } = props;
  const { isEmpty, getDataTableProps } = useInquiryList(filter);
  const [tableData, setTableData] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(
    getDataTableProps().pagination?.pageIndex + 1
  );
  const [pageSize, setPageSize] = React.useState(
    getDataTableProps().pagination?.pageSize
  );
  const [totalData, setTotalData] = React.useState(getDataTableProps().total);
  const [pageCount, setPageCount] = React.useState(
    getDataTableProps().pageCount
  );
  const [isEmptyResult, setIsEmptyResult] = React.useState(false);
  const onSave = async () => {
    await fetchInquiryDownload().then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `inquiry-${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  React.useEffect(() => {
    if (isEmpty) {
      setIsEmptyResult(true);
    } else {
      setIsEmptyResult(false);
    }
  }, [isEmpty]);

  React.useEffect(() => {
    if (!isEmpty) {
      setTableData(getDataTableProps()?.data);
      setCurrentPage(getDataTableProps()?.pagination?.pageIndex + 1);
      setPageSize(getDataTableProps().pagination?.pageSize);
      setTotalData(getDataTableProps().total);
      setPageCount(getDataTableProps().pageCount);
    }
  }, [getDataTableProps()]);
  return (
    <>
      <Table
        {...getDataTableProps()}
        hasSort={false}
        // data={tableData}
        // pageCount={pageCount}
        onSave={onSave}
        hasPageSizeFilter={false}
        columns={columns(currentPage, pageSize, totalData)}
        {...getDataTableProps()}
      />

      {isEmptyResult && (
        <Modal
          isOpenFromOutside={isEmptyResult}
          setIsOpenFromOutside={setIsEmptyResult}
          description="검색결과가 없습니다."
          hasCancel={false}
        />
      )}
    </>
  );
}
